module.exports = __webpack_public_path__ + "img/admin-menu-abierto.92bbd23e.svg";